/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Filter_In_ReviewInputs */

const en_cases_filter_in_review = /** @type {(inputs: Cases_Filter_In_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In review`)
};

const pt_br2_cases_filter_in_review = /** @type {(inputs: Cases_Filter_In_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em revisão`)
};

/**
* | output |
* | --- |
* | "In review" |
*
* @param {Cases_Filter_In_ReviewInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_filter_in_review = /** @type {((inputs?: Cases_Filter_In_ReviewInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Filter_In_ReviewInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_filter_in_review(inputs)
	return pt_br2_cases_filter_in_review(inputs)
});